import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#0A66C2',     // LinkedIn Blue
      light: '#057642',    // Success Green
      dark: '#004182',     // Dark Blue
      contrastText: '#fff',
    },
    secondary: {
      main: '#00000099',   // LinkedIn Text
      light: '#00000066',  // LinkedIn Secondary Text
      dark: '#000000E6',   // LinkedIn Primary Text
    },
    background: {
      default: '#F8FAFC',  // Lighter background
      paper: '#FFFFFF',    // White
    },
    error: {
      main: '#CC1016',     // LinkedIn Error Red
    }
  },
  typography: {
    fontFamily: 'var(--font-family)',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
      fontWeight: 700,
      fontSize: '3rem',
      color: '#000000E6',
      fontFamily: 'var(--font-family)',
      marginBottom: '0.5em',
    },
    h2: {
      fontWeight: 700,
      fontSize: '2.5rem',
      color: '#000000E6',
      fontFamily: 'var(--font-family)',
    },
    h3: {
      fontWeight: 600,
      fontSize: '2rem',
      color: '#000000E6',
      fontFamily: 'var(--font-family)',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.5rem',
      color: '#000000E6',
      fontFamily: 'var(--font-family)',
    },
    h5: {
      fontWeight: 500,
      color: '#00000099',
      fontFamily: 'var(--font-family)',
    },
    h6: {
      fontWeight: 600,
      color: '#000000E6',
      fontFamily: 'var(--font-family)',
    },
    subtitle1: {
      fontFamily: 'var(--font-family)',
      fontWeight: 500,
      color: '#00000099',
    },
    subtitle2: {
      fontFamily: 'var(--font-family)',
      fontWeight: 500,
      color: '#00000066',
    },
    button: {
      fontFamily: 'var(--font-family)',
      fontWeight: 600,
    },
    body1: {
      fontFamily: 'var(--font-family)',
      fontSize: '1rem',
    },
    body2: {
      fontFamily: 'var(--font-family)',
      fontSize: '0.875rem',
    },
    caption: {
      fontFamily: 'var(--font-family)',
      fontSize: '0.75rem',
      color: '#00000099',
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#0A66C2',
          color: '#fff',
          boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
          zIndex: 1000,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: '24px',
          padding: '6px 16px',
        },
        outlined: {
          borderColor: '#0A66C2',
          '&:hover': {
            borderColor: '#004182',
            backgroundColor: 'rgba(10, 102, 194, 0.04)',
          },
        },
        contained: {
          backgroundColor: '#0A66C2',
          color: '#FFFFFF',
          '&:hover': {
            backgroundColor: '#004182',
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        '@keyframes blink': {
          'from, to': { borderColor: 'transparent' },
          '50%': { borderColor: '#0A66C2' },
        },
        body: {
          backgroundColor: '#F8FAFC',
          backgroundImage: `
            radial-gradient(#0A66C2 0.5px, transparent 0.5px), 
            radial-gradient(#0A66C2 0.5px, #F8FAFC 0.5px)
          `,
          backgroundSize: '20px 20px',
          backgroundPosition: '0 0, 10px 10px',
          backgroundAttachment: 'fixed',
          opacity: 0.98
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
          borderRadius: '12px',
        },
      },
    },
  },
}); 